import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GolfHero } from "../components/golf/GolfHero";
import { CourseDetails } from "../components/golf/CourseDetails";
import { RatesSection } from "../components/golf/RatesSection";
import { FacilitiesSection } from "../components/golf/FacilitiesSection";
import { BookingSection } from "../components/golf/BookingSection";

const Golf = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 150);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div>
      <GolfHero />
      <CourseDetails />
      <RatesSection />
      <FacilitiesSection />
      <BookingSection />
    </div>
  );
};

export default Golf;
